// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const EMOJI_REACTION_ANGRY = "\u0160tve m\u011b to";
export const EMOJI_REACTION_CARE = "Pos\u00edl\u00e1m podporu";
export const EMOJI_REACTION_HAHA = "Pobavilo";
export const EMOJI_REACTION_LIKE = "L\u00edb\u00ed se mi";
export const EMOJI_REACTION_LOVE = "Skv\u011bl\u00e9";
export const EMOJI_REACTION_SAD = "Mrz\u00ed m\u011b to";
export const EMOJI_REACTION_WOW = "P\u0159ekvapilo";
